// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"f468b3b6","487":"bda45626","554":"792ed1cc","599":"4c6b0702","841":"62d3a807"}[chunkId] + ".chunk.js";
};